export enum LauncherEventType {
  NetworkMessage = "NetworkMessage",
  NetworkConnected = "NetworkConnected",
  NetworkLosing = "NetworkLosing",
  NetworkDisconnected = "NetworkDisconnected",
  ChangeIsland = "ChangeIsland",
  GetUser = "GetUser",
  GetClasses = "GetClasses",
  GetLocale = "GetLocale",
  GetFeatureSwitches = "GetFeatureSwitches",
  Reload = "Reload",
  GetEditorAssets = "GetEditorAssets",
  IframeLoaded = "IframeLoaded",
}

export const iFrameLauncherEvent = "iFrameLauncherEvent" as const;

export type iFrameLauncherMessage = {
  iFrameLauncherEvent: "iFrameLauncherEvent";
  type: LauncherEventType;
  data?: string | Uint8Array;
};
